export class LinkedinEmailModel {
  from: string;
  to: string;
  subject: string;
  message: string;
  attachmentName: string;
  fileList: any;
}
